import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const FileUpload: ComponentStyleConfig = {
  parts: [
    'Root',
    'Container',
    'FileCard',
    'Title',
    'Description',
    'UploadedFilesContainer',
    'UploadedFilesTitle',
    'TotalSizeText',
    'UploadIconProps',
  ],
  baseStyle: (props: StyleFunctionProps) => ({
    Root: { flexDirection: 'column', gap: 4 },
    Container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      p: 8,
      minH: 24,
      border: '2px dashed',
      borderColor: mode('gray.300', 'white')(props),
      bg: mode('white', 'gray.500')(props),
      w: 'inherit',
      cursor: 'pointer',
      boxShadow: 'xl',
      gap: 6,
      _hover: { borderColor: `${props.colorTheme || 'blue'}.500` },
    },
    FileCard: {
      flexDirection: 'column',
      border: '1px solid',
      borderColor: mode('gray.300', 'gray.500')(props),
      p: 4,
    },
    Title: { alignItems: 'center' },
    Description: {
      ml: 'auto',
      color: mode('gray.500', 'gray.200')(props),
      fontSize: 'xs',
    },
    UploadedFilesContainer: { gap: 4, flexDirection: 'column' },
    UploadedFilesTitle: { alignItems: 'center' },
    TotalSizeText: {
      ml: 'auto',
      color: mode('gray.500', 'gray.200')(props),
      fontSize: 'xs',
    },
    UploadIconProps: { fontSize: 56 },
  }),
};

export default FileUpload;
